import { MutationCache, QueryClient } from '@tanstack/react-query';

import { matchesAnyQueryKey } from './_utils/matchesAnyQueryKey';

const createQueryClient = () => {
  const client: QueryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: async (_data, _variables, _context, mutation) => {
        if (mutation.meta) {
          const { reset, invalidates } = mutation.meta;

          if (reset) {
            client.resetQueries({
              predicate: (query) => matchesAnyQueryKey(query.queryKey, reset),
            });
          }
          if (invalidates) {
            await client.invalidateQueries({
              predicate: (query) =>
                matchesAnyQueryKey(query.queryKey, invalidates),
            });
          }
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 300_000,
        retry: 2,
        retryDelay: 1_000,
      },
    },
  });

  return client;
};

let browserQueryClient: QueryClient | undefined;

//* 서버는 요청마다 새 인스턴스를 만든다 — 모듈 스코프 하나를 공유하면 HydrationBoundary가
//* 채운 한 사용자의 데이터가 같은 Node 프로세스의 다음 요청 렌더에 그대로 나간다.
export const getQueryClient = () => {
  if (typeof window === 'undefined') {
    return createQueryClient();
  }

  browserQueryClient ??= createQueryClient();

  return browserQueryClient;
};
